<template>
  <div v-if="isMobie()" key="">
    <MApp />
  </div>
  <div class="comtent" v-else>
    <img src="@/assets/shouye_bg@2x.png" class="comtent-img" alt="">
    <div class="title-box" id="title-box">
      <img src="@/assets/uxpay_logo.png" @click="cliText(0)" :class="{ actives: color == 0 }" class="text1" alt="">
      <span @click="cliText(0)" :class="{ active: color == 0 }" class="text">{{ $t('content5') }}</span>
      <span @click="cliText(1)" :class="{ active: color == 1 }" class="text">{{ $t('content6') }}</span>
      <span @click="cliText(2)" :class="{ active: color == 2 }" class="text">{{ $t('content7') }}</span>
      <span @click="cliText(3)" :class="[{ active: color == 3 }, $i18n.locale + '_text2']">{{ $t('content8') }} <img
          src="@/assets/open.png" class="con-7" alt=""></span>
      <span @click="cliText(4)" :class="{ active: color == 4 }" class="text">{{ $t('content13') }}</span>
      <div class="pos-s">
        <!-- <el-select v-model="value" placeholder="中文" size="large" class="custom-select">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
        </el-select> -->
        <div class="custom-select" @click="toggleDropdown">
          <img src="@/assets/Slice 51.png" alt="" class="slice-51">
          <span id="textZH"></span>
          <img src="@/assets/xiala_icon@2x.png" class="xiala" alt="">
        </div>
        <ul class="dropdown-options" v-if="isDropdownOpen">
          <li v-for="item in options" :key="item.value" @click="selectOption(item)">{{ item.label }}</li>
        </ul>
      </div>
      <div class="pos-a" @click="openUrl">{{ $t('content14') }}</div>
    </div>
    <home v-if="color == 0"></home>
    <pay v-if="color == 1"></pay>
    <ment v-if="color == 2"></ment>
    <regarding v-if="color == 4"></regarding>

    <div class="open-box" :class="$i18n.locale + '_open-box'" v-if="ft" @mouseenter="ft = true"
      @mouseleave="ft = false">
      <div class="open-flex" :class="{ activeOpen: opencli == 0 && isSelect }" @click="openclis(0)">
        <img src="@/assets/yongjin_icon@2x.png" class="con-8" alt="">
        <div class="open-text">{{ $t('content9') }}</div>
      </div>
      <div class="open-flex" :class="{ activeOpen: opencli == 1 }" @click="openclis(1)">
        <img src="@/assets/fafang_icon@2x.png" class="con-8" alt="">
        <div class="open-text">{{ $t('content10') }}</div>
      </div>
      <div class="open-flex" :class="{ activeOpen: opencli == 2 }" @click="openclis(2)">
        <img src="@/assets/gongyingshang_icon@2x.png" class="con-8" alt="">
        <div class="open-text">{{ $t('content11') }}</div>
      </div>
      <div class="open-flex" :class="{ activeOpen: opencli == 3 }" @click="openclis(3)">
        <img src="@/assets/youxi_icon@2x.png" class="con-8" alt="">
        <div class="open-text">{{ $t('content12') }}</div>
      </div>
    </div>

    <soliv1 v-if="color == 3 && opencli == 0 && isSelect"></soliv1>
    <soliv2 v-if="color == 3 && opencli == 1 && isSelect"></soliv2>
    <soliv3 v-if="color == 3 && opencli == 2 && isSelect"></soliv3>
    <soliv4 v-if="color == 3 && opencli == 3 && isSelect"></soliv4>


    <div class="bottom-Filmny">
      <div class="bottom-Filmny-box">
        <div :class="$i18n.locale + '_Filmny-left'">
          <img src="@/assets/uxpay_logo.png" class="con-img" alt="">
          <div class="con-1">{{ $t('content16') }}</div>
          <div class="con-2">
            <img src="@/assets/message1.png" class="con-2-img" alt="">
            <div class="con-3">uxpay@uxpay.com</div>
          </div>
        </div>
        <div class="Filmny-right">
          <div>
            <div class="Filmny-text-3">{{ $t('content5') }}</div>
            <div class="Filmny-text-6" @click="payprod">{{ $t('content5') }}</div>
          </div>

          <div class="con-4">
            <div class="Filmny-text-3">{{ $t('content6') }}</div>
            <div class="Filmny-text-6" @click="goPay">{{ $t('content6') }}</div>
          </div>

          <div class="con-5">
            <div class="Filmny-text-3">{{ $t('content7') }}</div>
            <div class="Filmny-text-6" @click="index1">{{ $t('content8') }}</div>
            <div class="Filmny-text-6" @click="index2">{{ $t('content9') }}</div>
            <div class="Filmny-text-6" @click="index3">{{ $t('content10') }}</div>
            <div class="Filmny-text-6" @click="index4">{{ $t('content11') }}</div>
          </div>

          <div class="con-6">
            <div :class="$i18n.locale + '_Filmny-text-3'">{{ $t('content13') }}</div>
            <div class="Filmny-text-6" @click="gywm">{{ $t('content13') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="bottom-Filmny-2">
        <div class="Filmny-text-7"></div>
        <div class="Filmny-text-8">Copyright © {{ currentYear }} uxpay.com {{ $i18n.locale == 'zh' ? '版权所有' : '' }}</div>
        <!-- <div class="Filmny-text-8">京ICP备18018888号-1</div> -->
      </div>
    </div>
    <div class="QRCode-box" v-if="showContactWay && showContactWayNumber === 1">
      <div class="contact-QRCode">
        <img src="@/assets/wx_img2.jpg" class="QRCode" alt="">
      </div>
      <div class="QRCode-wenzi">{{ $t('content196') }}</div>
    </div>
    <div class="QRCode-box" v-if="showContactWay && showContactWayNumber === 3">
      <div class="contact-QRCode">
        <img src="@/assets/appicon.png" class="QRCode" alt="">
      </div>
      <div class="QRCode-wenzi">{{ $t('content196') }}</div>
    </div>
    <div class="contact-Email" v-if="showContactWay && showContactWayNumber === 2">
      <div class="youxiang">
        {{ $t('content15') }}
      </div>
      <div class="email">
        uxpay@uxpay.com
      </div>
    </div>
    <div class="relation-box" style="">
      <div ><img src="@/assets/wx_icon@2x.png" class="qr-1" alt="" @click="openQRCode(1)">
        <div class="cfont">WeChat</div>
      </div>
        <div class="line-1"></div>
      <div>
      <img src="@/assets/en_whatsapp_icon@2x.png" class="qr-1" alt="" @click="openAPP(3)">
<div class="cfont">whatsapp</div>
      </div>
      <div class="line-1"></div>
      <div>
      <img src="@/assets/email_icon@2x.png" class="email-0" alt="" @click="openEmail(2)">
      <div class="cfont">email</div>
      </div>
    </div>
  </div>
</template>

<script>
import home from '@/home/homePage'
import pay from '@/pay/payPage'
import ment from '@/payment/payment'
import regarding from '@/regarding/regarding'
import soliv1 from '@/soliv/index1.vue'
import soliv2 from '@/soliv/index2.vue'
import soliv3 from '@/soliv/index3.vue'
import soliv4 from '@/soliv/index4.vue'
import { toRaw } from '@vue/reactivity'
import { switchLanguage } from '../src/main'
import MApp from '@/components/DApp .vue'



export default {
  components: {
    home,
    pay,
    ment,
    regarding,
    soliv1,
    soliv2,
    soliv3,
    soliv4,
    MApp
  },
  name: 'App',
  data() {
    return {
      color: 0,
      opencli: undefined,
      ft: false,
      showContactWay: false,
      showContactWayNumber: 1,
      show: false,
      options: [
        {
          value: 'zh',
          label: '中文',
        },
        {
          value: 'en',
          label: 'English',
        },
      ],
      value: undefined,
      isDropdownOpen: false,
      selectedOption: null,
      isSelect: false,
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  mounted() {
    document.getElementById('textZH').textContent = localStorage.getItem('lang') == 'en' ? 'English' : '中文'
    document.addEventListener('click', this.handleClickOutside)
    window.addEventListener('scroll', function () {
      const floatingDiv = document.getElementById('title-box');
      const scrollPosition = window.scrollY;

      // 根据滚动位置改变背景色
      if (scrollPosition > 0) {
        floatingDiv.style.backgroundColor = 'white';
      } else {
        floatingDiv.style.backgroundColor = '';
      }
    });
    window.onload = function () {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 10);
    };
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    isMobie() {
      return /Android|webOS|iPhone|iPad|iPad por|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    openUrl() {
      window.open('https://mer.uxpay.com/#/register', '_blank');
    },
    handleClickOutside(e) {
      if (e.target.className == 'qr-1' && this.showContactWay) return
      if (e.target.className == 'email-0' && this.showContactWay) return
      if ((e.target.className !== 'QRCode' || e.target.className !== 'qr-1' || e.target.className !== 'QRCode-box') && this.showContactWay) {
        this.showContactWay = false
      }
      if ((e.target.className !== 'contact-Email' || e.target.className !== 'email-0') && this.showContactWay) {
        this.showContactWay = false
      }
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectOption(item) {
      const rawItem = toRaw(item);
      this.selectedOption = rawItem;
      this.isDropdownOpen = false;
      switchLanguage(rawItem.value)
      window.location.reload()

    },
    cliText(index) {
      if (index !== 3) {
        this.color = index
        // setTimeout(() => {
        //   this.ft = false
        // }, 2000)
      } else {
        this.ft = true
      }
      if (this.opencli !== undefined && index == 3) {
        this.isSelect = true
      } else {
        this.isSelect = false
        this.opencli = undefined
      }
    },
    openclis(index) {
      this.isSelect = true
      this.color = 3
      this.opencli = index
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
    },
    payprod() {
      this.color = 1
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
      // this.$router.push('/payPage')
    },
    goPay() {
      this.color = 2
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
      // this.$router.push('/payment')
    },
    gywm() {
      this.color = 4
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
    },
    index1() {
      this.color = 3
      this.opencli = 0
      this.isSelect = true
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
    },
    index2() {
      this.color = 3
      this.opencli = 1
      this.isSelect = true
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
    },
    index3() {
      this.color = 3
      this.opencli = 2
      this.isSelect = true
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
    },
    index4() {
      this.color = 3
      this.opencli = 3
      this.isSelect = true
      window.scrollTo({
        top: 0,
        behavior: 'smooth'  // 启用平滑滚动
      });
    },
    openQRCode(e) {
      this.showContactWayNumber = e
      this.showContactWay = true
    },
    openAPP(e) {
      this.showContactWayNumber = e
      this.showContactWay = true
    },
    openEmail(e) {
      this.showContactWayNumber = e
      this.showContactWay = true
    },
  }

}
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
}

.comtent-img {
  position: absolute;
  top: 0;
  left: 0;
  height: 1113px;
  z-index: -2;
}

.comtent {
  padding: 0 auto;
  margin: 0 auto;
  background-color: #f5f8ff;
}


.body {
  padding: 0 auto;
  margin: 0 auto;
}

.title-box {
  margin-left: 360px;
  margin-top: 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: fixed;
  z-index: 10000;
  width: 62%;
  border-radius: 5px;
}

.active {
  color: #4873FF;
  font-weight: 600;
  border-bottom: 3px solid #4873FF;

}

.actives {
  color: #007bff;
  font-weight: 600;
}

.text {
  margin-right: 50px;
  font-size: 20px;
  padding-bottom: 10px;
  /* width: 120px; */
  height: 35px;
  line-height: 35px
}

.text1 {
  margin-right: 58px;

  padding-bottom: 10px;
  /* width: 120px; */
  height: 35px;
  line-height: 35px
}

.zh_text2 {
  margin-right: 67px;
  font-size: 20px;
  padding-bottom: 10px;
  height: 35px;
  line-height: 35px;
}

.en_text2 {
  margin-right: 10px;
  font-size: 20px;
  padding-bottom: 10px;
  height: 35px;
  line-height: 35px;
}


.pos-a {
  border-radius: 5px;
  background-color: #4873ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
  height: 36px;
  font-size: 14px;
  position: fixed;
  right: 360px;
}

.bg {
  /* width: 100%; */
  /* height: 100%; */
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.bottom-Filmny {
  height: 320px;
  background-color: #F8F9FF;
  padding-top: 87px;
  cursor: pointer;

}

.bottom-Filmny-box {
  width: 1169px;
  margin: 0 auto;
  height: 255px;
  display: flex;
  justify-content: space-between;
}


.zh_Filmny-left {
  width: 300px;
}

.en_Filmny-left {
  width: 340px;
}

.Filmny-right {
  display: flex;

}

.con-img {
  width: 171px;
  height: 51px;
}

.zh_Filmny-text-3 {
  font-size: 20px;
  color: #333333;
  font-weight: 600;
}

.en_Filmny-text-3 {
  width: 120px;
}

.Filmny-text-6 {
  font-size: 20px;
  color: #666666;
  margin-top: 20px;
}

.open-box {
  /* width: 323px; */
  /* height: 366px; */
  border-radius: 24px;
  background-color: #fff;
  position: fixed;
  /* left: 666px; */
  top: 88px;
  cursor: pointer;
  padding: 15px;
  z-index: 100002;
}

.zh_open-box {
  width: 323px;
  left: 700px
}

.en_open-box {
  width: 400px;
  left: 800px
}

.open-text {
  font-size: 18px;
  color: #666666;
  margin-left: 17px;
}

.open-flex {
  display: flex;
  align-items: center;
  width: 300px;
  height: 80px;
  margin: 0 auto;
}

.activeOpen {
  width: 300px;
  height: 80px;
  background-color: #F3F6FF;
  border-radius: 15px;
  color: #4873FF;
}

.con-1 {
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}

.con-2 {
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.con-2-img {
  width: 20px;
  height: 16px;
  margin-top: 5px;
}

.con-3 {
  margin-left: 9px;
  font-size: 20px;
  color: #333333;
}

.con-4 {
  margin-left: 115px;
}

.con-5 {
  margin-left: 109px;
}

.con-6 {
  margin-left: 131px;
}

.con-7 {
  width: 13px;
  height: 13px;
  margin-left: 5px;
}

.con-8 {
  width: 40px;
  height: 40px;
  margin-left: 27px;
}

.pos-s {
  color: #fff;
  display: flex;
  align-items: center;
  background-color: white;
  justify-content: center;
  width: 110px;
  border-radius: 5px;
  height: 36px;
  font-size: 14px;
  position: fixed;
  right: 480px;
}

.cfont {
  font-size: 16px;
}

.line-1 {
 height: 1px;
    background-color: #666666;
    width: 40px;
    margin-bottom: 10px;
    margin-top: 10px;
}

.relation-box {
  width: 80px;
  height: 300px;
  background-color: #ffffff;
  position: fixed;
  top: 50%;
  right: 1%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  box-shadow: 0px 0px 20px 0px rgba(235, 239, 250, 0.9);
  text-align: center;
  z-index: 10000;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}



.email-0 {
  /* max-width: 100%; */
  height: 50px;
  width: 50px;
}

.contact-QRCode {
  position: fixed;
  top: 43%;
  right: 12%;
  z-index: 10000;
  width: 198px;
  height: 198px;
  /* background-color: white; */
  border-radius: 10px;
  /* border: 3px solid #4873ff; */
}

.QRCode-box {
  width: 240px;
  height: 280px;
  background-color: #e1e7ff;
  z-index: 10000;
  position: fixed;
  top: 40%;
  right: 11%;
  border-radius: 20px;
}

.QRCode {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.QRCode-wenzi {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 240px;
  font-size: 22px;
}

.contact-Email {
  height: 100px;
  border-radius: 5px;
  width: 300px;
  font-size: 18px;
  position: fixed;
  top: 52%;
  right: 10%;
  z-index: 10000;
  background-color: #e1e7ff;
  text-align: center;
}

.youxiang {
  margin-top: 20px;
}

.qr-1 {
  /* margin-bottom: 10px; */
  /* border-bottom: 2px solid #6666; */
  height: 50px;
  width: 50px;
}

.custom-select {
  position: relative;
  /* padding: 8px 12px; */
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  color: black;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.slice-51 {
  margin-right: 6px;
  margin-left: 6px;
  /* height: 18px;
  width: 18px; */
}

.xiala {
  position: absolute;
  left: 75%;
  /* height: 18px;
  width: 18px; */
}

.dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  padding: 8px 0;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background-color: #fff;
  list-style-type: none;
  z-index: 1000;
}

.dropdown-options li {
  padding: 8px 12px;
  cursor: pointer;
  color: black;
}

.dropdown-options li:hover {
  background-color: #f5f7fa;
}

.bottom-Filmny-2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 80px;
  background-color: #F8F9FF;
  color: #666666;
  font-size: 20px;
}

.Filmny-text-8 {
  font-size: 22px;
}

.Filmny-text-7 {
  height: 1px;
  background-color: #292929;
  width: 70%;
  margin-bottom: 32px;
}
</style>
